import Dialog from "primevue/dialog";
import {ref, onMounted, computed} from "vue";
import Button from "primevue/button";

export default {
    props: ['visible', 'header', 'content', 'actionLabel'],
    emits: ['close', 'accept'],
    components: {
        Button,
        Dialog
    },
    setup(props, context) {

        const show = computed(() => {
            return !!props.visible && props.visible;
        });
        const header = ref('');
        const content = ref('');
        const actionLabel = ref('');

        onMounted(() => {
            show.value = props.visible;
            header.value = props.header;
            content.value = props.content;
            actionLabel.value = props.actionLabel;
        });

        const close = () => {
            context.emit('close');
        }

        const accept = () => {
            context.emit('accept');
        }

        return {show, close, accept}
    }
}
